import axios from 'axios'

import { requestInterceptor } from './request-interceptor'

const interceptor = (): void => {
  axios.interceptors.request.use(requestInterceptor, (error) => {
    // Do something with request error
    return Promise.reject(error)
  })
}

export { interceptor }
